import React from 'react';
import { CheckCircle, Lock } from 'lucide-react';
const PURCHASE_URL = 'https://digitalespro.com/cart/47867900788950:1';
export function PricingSection() {
  return <section id="compra" className="bg-[#1a1a2e] py-10 md:py-16 px-4 text-white relative overflow-hidden scroll-mt-4" data-id="element-88">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-89">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-90"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-91"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-92">
        <div className="text-center mb-8" data-id="element-93">
          <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded animate-bounce mb-3 text-sm" data-id="element-94">
            ⏰ Oferta por tiempo limitado
          </div>
          <h2 className="text-3xl md:text-4xl font-black mb-2 font-['Oswald'] uppercase" data-id="element-95">
            Hoy te llevas TODO el pack
          </h2>
          <p className="text-yellow-400 text-lg font-bold" data-id="element-96">+ BONOS GRATIS</p>
          <p className="text-gray-400 text-sm mt-1" data-id="element-97">
            (Esto no estará disponible para siempre)
          </p>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl shadow-2xl overflow-hidden max-w-lg mx-auto border-4 border-green-400" data-id="element-98">
          <div className="bg-gray-100 p-4 border-b border-gray-200 text-center" data-id="element-99">
            <h3 className="text-lg font-bold text-gray-600 uppercase tracking-wide" data-id="element-100">
              📦 Lo que vas a recibir hoy:
            </h3>
          </div>

          <div className="p-6 md:p-8" data-id="element-101">
            <ul className="space-y-3 mb-6" data-id="element-102">
              <li className="flex items-center gap-3 text-base font-bold" data-id="element-103">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-104" />
                <span data-id="element-105">📘 Guía Principal del Cuerpo Humano</span>
              </li>
              <li className="flex items-center gap-3 text-base" data-id="element-106">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-107" />
                <span data-id="element-108">📝 Bono #1: Kit Premium de Evaluaciones</span>
              </li>
              <li className="flex items-center gap-3 text-base" data-id="element-109">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-110" />
                <span data-id="element-111">🎲 Bono #2: MegaPack Juegos Didácticos</span>
              </li>
              <li className="flex items-center gap-3 text-base" data-id="element-112">
                <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-113" />
                <span data-id="element-114">📅 Bono #3: Planificador Estratégico</span>
              </li>
            </ul>

            <div className="text-center mb-6" data-id="element-115">
              <p className="text-gray-400 line-through text-lg mb-1" data-id="element-116">
                Valor total real: $ 49990
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-117">
                <span className="text-xl font-bold text-gray-700" data-id="element-118">
                  HOY SOLO:
                </span>
                <span className="text-4xl md:text-5xl font-black text-[#22c55e]" data-id="element-119">
                  $ 19990
                </span>
              </div>
            </div>

            <a href={PURCHASE_URL} target="_blank" rel="noopener noreferrer" className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white text-lg md:text-xl font-black py-4 px-4 rounded-lg shadow-[0_4px_0_#15803d] active:shadow-[0_2px_0_#15803d] active:translate-y-1 transition-all uppercase flex items-center justify-center gap-2 animate-pulse mb-4 no-underline" data-id="element-120">
              🚀 QUIERO ACCEDER AHORA
            </a>

            <div className="flex items-center justify-center gap-2 text-xs text-gray-500 font-medium" data-id="element-121">
              <Lock className="w-3.5 h-3.5" data-id="element-122" />
              <span data-id="element-123">Compra segura · Acceso inmediato después del pago</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}